import { render, staticRenderFns } from "./spm-manage-add.vue?vue&type=template&id=f0b94218&scoped=true"
import script from "./spm-manage-add.vue?vue&type=script&lang=js"
export * from "./spm-manage-add.vue?vue&type=script&lang=js"
import style0 from "./spm-manage-add.vue?vue&type=style&index=0&id=f0b94218&scoped=true&lang=scss"
import style1 from "./spm-manage-add.vue?vue&type=style&index=1&id=f0b94218&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b94218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0b94218')) {
      api.createRecord('f0b94218', component.options)
    } else {
      api.reload('f0b94218', component.options)
    }
    module.hot.accept("./spm-manage-add.vue?vue&type=template&id=f0b94218&scoped=true", function () {
      api.rerender('f0b94218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/spm/spm-manage/spm-manage-add.vue"
export default component.exports